import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from '../../layout/container/container.component';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-why-unipay',
  standalone: true,
  imports: [CommonModule, ContainerComponent],
  templateUrl: './why-unipay.component.html',
  styleUrl: './why-unipay.component.scss'
})
export class WhyUnipayComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sectionElement', { static: false }) sectionElement?: ElementRef;

  constructor(private readonly analyticsService: AnalyticsService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.sectionElement?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.sectionElement.nativeElement,
        'Why Unipay',
        'why-unipay-section'
      );
    }
  }

  ngOnDestroy() {
    // Unregister section from analytics tracking
    if (this.sectionElement?.nativeElement) {
      this.analyticsService.unregisterSectionFromTracking(this.sectionElement.nativeElement);
    }
  }
}
